import React from "react";

import { Tag } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

const Settings = (props) => (
    <div>
        {props.task.ICEMatches && (
            <Tag key="1" icon={<CheckCircleOutlined />} color="processing">
                ICE Matches
            </Tag>
        )}
        {props.task.repetitions && (
            <Tag key="2" icon={<CheckCircleOutlined />} color="processing">
                Repetitions
            </Tag>
        )}
        {props.task.matches100 && (
            <Tag key="3" icon={<CheckCircleOutlined />} color="processing">
                100% Matches
            </Tag>
        )}
        {props.task.machineTranslation && (
            <Tag key="4" icon={<CheckCircleOutlined />} color="processing">
                Machine Translation
            </Tag>
        )}
    </div>
);

export default Settings;
